"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentBoundaryInferenceReportEntrySchema = void 0;
const zod_1 = require("zod");
const ComponentBoundary_1 = require("../ComponentBoundary");
const InferenceReportEntryBase_1 = require("./InferenceReportEntryBase");
exports.ComponentBoundaryInferenceReportEntrySchema = InferenceReportEntryBase_1.InferenceReportEntryBaseSchema.extend({
    source: zod_1.z
        .literal('model')
        .or(zod_1.z.literal('inferred'))
        .or(zod_1.z.literal('default'))
        .or(zod_1.z.literal('hil')),
    boundary: ComponentBoundary_1.ComponentBoundarySchema,
});
//# sourceMappingURL=ComponentBoundaryInferenceReportEntry.js.map